import { DataQueryCategory } from './data-query-category.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

export class DataQueryObject {

    // Server Properties
    Categories: DataQueryCategory[] = [];
    Deleted: boolean;
    ID: number;
    ObjectName: string;
    DisplayName: string;

    // Local Properties
    private _tableData: TylerMatTableDataSource;

    // class functions
    get tableData(): TylerMatTableDataSource {
        if (!this._tableData) {
            this._tableData = new TylerMatTableDataSource(this.categories);
        }
        if (this._tableData.data != this.categories) {
            this._tableData.data = this.categories;
        }
        return this._tableData;
    }

    get categories(): DataQueryCategory[] {
        return this.Categories;
    }

    set categories(value: DataQueryCategory[]) {
        this.Categories = value;
    }
}